"use client";
import ShareButton from "@/components/views/company-discounts/ShareButton";
import DropdownPart from "@/components/views/company-discounts/DropdownPart";
import { useCompanyContext } from "@/context/CompanyContext";
import { useEffect, useState } from "react";
import { useSite } from "@/lib/hooks/site";
import { useRouter } from "next/navigation";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  companyData: any;
  slug: string;
}

export default function CompanyHeader({ companyData, slug }: Props) {
  const { t } = useTranslation();
  const { companyFilters } = useCompanyContext();
  const site = useSite();
  const router = useRouter();

  const showLine = () =>
    companyFilters.district?.id && companyFilters.service?.id;

  useEffect(() => {
    if (site?.setting?.disabledPages?.company === 1) {
      router.push("/404");
    }
  }, [site]);

  return (
    <div className="w-full flex flex-col justify-center">
      <div className="flex py-2 justify-between container flex-wrap max-sm:flex-col gap-2">
        <div className="flex flex-col gap-2">
          <div>
            <h1 className="font-bold text-xl max-md:py-1 text-primary">
              {companyData?.title}
            </h1>

            <div className="flex flex-col">
              <span className="font-bold text-[16px] text-primary">
                {t("company-detail-page-description", {
                  short_description: companyData?.shortDescription,
                  discount: companyData?.discount,
                })}
              </span>

              <span className="text-primary text-[20px] font-bold tracking-wider">
                {companyFilters?.district?.title}

                {showLine() ? " - " : ""}

                {companyFilters?.service?.title}
              </span>
            </div>
          </div>

          <ShareButton shareButtonText={companyData?.shareButtonText} slug={slug} />
        </div>

        <div className="flex z-[21] relative gap-2 flex-wrap items-center">
          <DropdownPart slug={slug} />
        </div>
      </div>

      <div className="w-full h-[1px] bg-stone-50"></div>
    </div>
  );
}
